import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialInstitutionConfidentialityDeedState: Dtos.InstitutionConfidentialityDeed & IRegistrationFormState = {
    id: null,
    institutionId: null,
    institution: null,
    name: null,
    location: null,
    dateOfDeed: null,
    dateFullyExecuted: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false
}

export interface IInstitutionConfidentialityDeedReduxFormState {
    id: IFieldState<number>,
    institutionId: IFieldState<number>,
    institution: IFieldState<Dtos.Institution>,
    name: IFieldState<string>,
    location: IFieldState<string>,
    dateOfDeed: IFieldState<string>,
    dateFullyExecuted: IFieldState<string>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>
}
